var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search__wrp" }, [
    _c("div", { staticClass: "search__input" }, [
      _c("span", { staticClass: "form__input-wrp" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword"
            }
          ],
          ref: "input",
          staticClass: "form__input",
          attrs: {
            placeholder: "请输入企业全称",
            type: "search",
            readonly: _vm.readonly
          },
          domProps: { value: _vm.keyword },
          on: {
            keyup: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.onEnter($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.selectItem(-1)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.selectItem(1)
              }
            ],
            blur: _vm.onBlur,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.keyword = $event.target.value
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.enterprises.length,
            expression: "enterprises.length"
          }
        ],
        ref: "list",
        staticClass: "reco-list__wrp"
      },
      [
        _c(
          "ul",
          { staticClass: "reco__list" },
          _vm._l(_vm.enterprises, function(enterprise, index) {
            return _c(
              "li",
              {
                key: enterprise.name,
                staticClass: "reco__item",
                class: { selected: _vm.selection == index },
                on: {
                  click: function($event) {
                    _vm.onClick(index)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "reco-item__desc",
                  domProps: { innerHTML: _vm._s(enterprise.name) }
                })
              ]
            )
          })
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-430217ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430217ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/SearchBox.vue
// module id = null
// module chunks = 